"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import BlankControl from "./BlankControl";
import { Messages } from "Messages";

var IsBlankControl =
/*#__PURE__*/
function (_BlankControl) {
  _inherits(IsBlankControl, _BlankControl);

  function IsBlankControl() {
    _classCallCheck(this, IsBlankControl);

    return _possibleConstructorReturn(this, _getPrototypeOf(IsBlankControl).apply(this, arguments));
  }

  _createClass(IsBlankControl, [{
    key: "render",
    value: function render() {
      this.$_element.text(Messages.Controls.IsBlank);
    }
  }]);

  return IsBlankControl;
}(BlankControl);

export { IsBlankControl as default };